<template>
  <card-container-layout>
    <div class="mb-3">
      <default-card-title-component
        text="AWARENESS"
      ></default-card-title-component>
    </div>
    <impression-stat-item :metric="impressionsMetric"></impression-stat-item>
    <card-info-text
      :text="label"
    ></card-info-text>
  </card-container-layout>
</template>
<script>
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
import CardInfoText from '../Common/CardInfoText.vue';
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import ImpressionStatItem from "../StatItems/ImpressionStatItem.vue"

export default {
  props: {
    impressionsMetric: [String, Number],
    label: [String]
  },
  components: {
    DefaultCardTitleComponent,
    CardInfoText,
    CardContainerLayout,
    ImpressionStatItem,
  },
};
</script>
